import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface GymMember {
  id: string;
  first_name: string | null;
  last_name: string | null;
  avatar_url: string | null;
}

export const useGymMembers = (gymId?: string | null) => {
  return useQuery({
    queryKey: ["gym-members", gymId],
    queryFn: async (): Promise<GymMember[]> => {
      const { data, error } = await supabase
        .from("profiles")
        .select("id, first_name, last_name, avatar_url")
        .eq("gym_id", gymId!)
        .eq("role", "socio")
        .eq("banned", false)
        .order("first_name");

      if (error) throw error;
      return data || [];
    },
    enabled: !!gymId,
  });
};
